import { cn } from "@/lib/utils";

export const LoadingSkeleton = ({ className, ...props }) => (
  <div
    className={cn("animate-pulse rounded-md bg-dark-surface-2", className)}
    aria-hidden="true"
    {...props}
  />
);

export const LoadingSkeletonBlock = ({ lines = 3, testId = "loading-skeleton" }) => (
  <div className="space-y-3" data-testid={testId} aria-busy="true" aria-label="Loading">
    {Array.from({ length: lines }).map((_, index) => (
      <LoadingSkeleton key={index} className={index === 0 ? "h-4 w-1/3" : "h-4 w-full"} />
    ))}
  </div>
);
